import { iconsPath } from "../../../../utils/imagePath";

export const PartnershipHeadings = [
  {
    title: 'Spatial Grid Partner Ecosystem',
    border: true,
  },

  {
    title: 'Go-To-Market (GTM) Partnership Aligned to Industry Verticals',
    border: true,
  },

  {
    title: 'Flexible Commercial Models: License Sales & Consulting Engagements',
    border: true,
  },

  {
    title: 'Partnership Agreements Built on Global Best Practices',
    border: true,
  },

  {
    title: 'Why Partner with Spatial Grid',
    border: true,
  },

  {
    title: 'Partner With Us',
    border: false,
  },
];
export const LicensingHeadings = [
  {
    title: 'Spatial Grid Licensing & Subscription Programs',
    border: true,
  },

  {
    title: 'Licensing Model Overview',
    border: true,
  },

  {
    title: 'Single User Monthly Subscription',
    border: true,
  },

  {
    title: 'Single User Annual Subscription',
    border: true,
  },

  {
    title: 'Multi User Annual Subscription',
    border: true,
  },

  {
    title: 'Three-Year Enterprise Subscription Program',
    border: false,
  },
  {
    title: 'Designed for Enterprise Adoption',
    border: false,
  },
  {
    title: 'Get in Touch',
    border: false,
  },
];
export const AlliancesHeadings = [
  {
    title: 'SpatialGrid Alliances',
    border: true,
  },

  {
    title: 'Type of Alliances',
    border: true,
  },

  {
    title: 'Alliances Objectives',
    border: true,
  },

  {
    title: 'Benefits',
    border: true,
  },

  
];

export const PrecticesTroubleshootingHeadings = [
  {
    title: 'Best Practices and Troubleshooting',
    border: true,
  },

  {
    title: 'Best Practices',
    border: true,
  },

  {
    title: 'Pitfalls to Avoid',
    border: true,
  },
];
export const HelpCenterData = [
  {
    title: 'Getting Started',
    desc: 'Welcome to Spatial Grid! Get started faster by learning some of the basics.',
    path: '/help-center/getting-started',
    icon: iconsPath?.gettingStarted,
  },
  {
    title: 'Using Spatial Grid',
    desc: 'Learn to navigate environments, use tools, and manage users, content, and experiences.',
    path: '/help-center/using-spatialgrid',
    icon: iconsPath?.usingSpatialGrid,
  },
  {
    title: 'Alliances',
    desc: 'Co-building IPs and joint assets for industry centric solutions',
    path: '/help-center/alliances',
    icon: iconsPath?.Alliance,
  },
  {
    title: 'Partnerships',
    desc: 'Deliver superior quality solutions for customers by partnering with system integrators',
    path: '/help-center/partnership',

    icon: iconsPath?.Partnerships,
  },
  {
    title: 'Best Practices & Troubleshooting',
    desc: 'Follow best practices and troubleshoot issues by reviewing technical guidelines.',
    path: '/help-center/practices-troubleshooting',
    icon: iconsPath?.Troubleshooting,
  },
  {
    title: 'Licensing',
    desc: 'Pricing comprises licensing and training of the platform with consulting services.',
    path: '/help-center/licensing',
    icon: iconsPath?.Licensing,
  },
];
export const helpCenterUseCases = [
  {
    title: 'Medha Servo Drives',
    path: '/all-industries/medha-servo-drives',
  },
  {
    title: 'Americana',
    path: '/all-industries/americana',
  },
  {
    title: 'Raghava Projects',
    path: '/all-industries/raghva-projects',
  },
  {
    title: 'RST Trading',
    path: '/all-industries/rst-trading',
  },
  {
    title: 'Creme 21',
    path: '/all-industries/creme21',
  },
  {
    title: 'Singareni Collieries',
    path: '/all-industries/singareni-collieries',
  },
  // {
  //   title: 'Defence and Space',
  //   path: '/all-industries/defence',
  // },
  {
    title: 'Education',
    path: '/all-industries/corpus-codex',
  },
  {
    title: 'Raghava Life Sciences',
    path: '/all-industries/raghva-life-sciences',
  },
  {
    title: 'Karnataka Tourism',
    path: '/all-industries/karnataka-tourism',
  },
];
